import type { ComponentType } from 'preact';
import type { LucideProps } from 'lucide-preact';
import { cn } from '@/lib/cn';

export interface IconProps extends Omit<LucideProps, 'ref'> {
  as: ComponentType<LucideProps>;
  size?: number;
  className?: string;
}

export function Icon({ as: Component, size = 16, className, strokeWidth = 2, ...rest }: IconProps) {
  return (
    <Component
      size={size}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
      aria-hidden="true"
      {...rest}
    />
  );
}
